Ext.define('WindowStanyLicznika', {
    extend: 'Ext.ux.window.WindowExd',
    alias: 'widget.app.WindowStanyLicznika',
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    border: true,
    width: 350,
    height: 650,
    layout: 'fit',
    scrollable: false,
    isstart: true,
    stanlicznika: null,
    photobase64: null,
    title: Lang.stany_licznika.capitalise(),
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: "panelcardexd",
            itemId: "panelcardexdown",
            items: [{
                xtype: "panel",
                layout: "fit",
                itemId: "startForm",
                flex: 1,
                items: [{
                    id: this.cid + "formpanel",
                    xtype: "form",
                    scrollable: WindowExdMobileDEVICEV || Ext.getViewportHeight() <= 650,
                    defaults: {
                        labelAlign: "top"
                    },
                    flex: 1,
                    columnWidth: 1,
                    items: [{
                        xtype: 'textfieldexd',
                        id: this.cid + "stanlicznika",
                        fieldLabel: this.isstart ? Lang.wprowadz_poczatkowy_stan_licznika_pojazdu.capitalise() : Lang.wprowadz_koncowy_stan_licznika_pojazdu.capitalise(),
                        anchor: '0',
                        allowBlank: false,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste.capitalise()
                    }, {
                        xtype: 'radiogroupexd',
                        id: this.cid + "photoexists",
                        name: "photoexists",
                        fieldLabel: Lang.zdjecie_zaladowane,
                        vertical: false,
                        allowBlank: false,
                        disabled: true,
                        items: [{
                            boxLabel: Lang.tak,
                            inputValue: true
                        }, {
                            boxLabel: Lang.nie,
                            inputValue: false,
                            value: true
                        }]
                    }, {
                        id: this.cid + "photo",
                        xtype: 'image',
                        src: '',
                        html: "Empty",
                        cls: 'custom-loadlicznik-photo-style',
                    }, {
                        id: this.id + "loadlicznikphoto",
                        xtype: 'button',
                        iconAlign: 'left',
                        ui: 'btn-secondary-s',
                        text: Lang.wgraj_zdjecie.capitalise(),
                        maxWidth: 150,
                        scope: this,
                        handler: this.loadPhoto
                    }],
                    buttons: [{
                        text: Lang.dalej.capitalise(),
                        clickEvent: "click",
                        ui: 'btn-primary-s',
                        scope: this,
                        handler: this.performNextStep
                    }, {
                        text: Lang.zamknij.capitalise(),
                        clickEvent: "click",
                        ui: 'btn-secondary-s',
                        scope: this,
                        handler: this.eclose
                    }]
                }]
            }, {
                xtype: "panel",
                layout: "fit",
                itemId: "resultForm",
                items: [{
                    xtype: "form",
                    scrollable: Ext.platformTags.touch,
                    defaults: {
                        labelAlign: "top"
                    },
                    columnWidth: 1,
                    scrollable: true,
                    items: [{
                        xtype: 'label',
                        id: this.cid + "resultText",
                        html: ''
                    }],
                    buttons: [{
                        text: Lang.zamknij.capitalise(),
                        clickEvent: "click",
                        ui: 'btn-secondary-s',
                        scope: this,
                        handler: this.eclose
                    }]
                }]
            }]
        }];
        this.callParent(arguments);
    },
    show: function () {
        this.setTitle(this.isstart ? Lang.stany_licznika_poczatkowe.capitalise() : Lang.stany_licznika_koncowe.capitalise());
        this.callParent(arguments);
    },
    loadPhoto: function () {
        var WindowLoadPhoto = Ext.create('WindowLoadPhoto', {
            parentObj: this
        });
        WindowLoadPhoto.show();
        WindowLoadPhoto.on("wclose", function (photoasbase64) {
            var imageComponent = Ext.getCmp(this.cid + "photo");
            if (photoasbase64 != null) {
                imageComponent.setSrc(photoasbase64);
                Ext.getCmp(this.cid + "photoexists").setValue(true);
                this.photobase64 = photoasbase64;
            }
        }, this);
    },
    afterRender: function () {
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.callParent(arguments);
    },
    performNextStep: function () {
        if (this.typwlasnosci == Const.TYP_WLASNOSCI_POJAZDU_WLASNY) {
            Ext.getCmp(this.cid + "stanlicznika").allowBlank = true;
        }
        Ext.getCmp(this.cid + "formpanel").isValid()
        var stanlicznika = Ext.getCmp(this.cid + "stanlicznika").getValue();
        if (this.typwlasnosci != Const.TYP_WLASNOSCI_POJAZDU_WLASNY && (stanlicznika == null || stanlicznika === '')) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        this.stanlicznika = stanlicznika;
        if (this.typwlasnosci != Const.TYP_WLASNOSCI_POJAZDU_WLASNY) {
            if (Ext.getCmp(this.cid + "photoexists").getValue() == null || this.photobase64 == null) {
                Ext.getCmp(this.cid + "photoexists").markInvalid(Lang.pole_nie_moze_byc_puste.capitalise());
                Ext.MessageBox.alert(Lang.error, Lang.w_przypadku_pojazdow_wynajmowanych_nalezy_dodac_zdjecie);
                return;
            }
        }
        this.wclose();
    },
    eclose: function () {
        this.fireEvent("eclose");
        this.close()
    },
    wclose: function () {
        this.fireEvent("wclose", this.stanlicznika, this.photobase64);
        this.close();
    }
});